export type Shadows =
  | 'card'
  | 'dropdown'
  | 'focusRing'
  | 'focusOutline'
  | 'dangerRing';

export const getFocusShadows = (colors) => ({
  focusOutline: `0 0 0 2px ${colors.interactive.focus.outer}`,
  focusRing: `0 0 0 2px ${colors.surface.background.primary}, 0 0 0 4px ${colors.interactive.focus.outer}`,
  dangerRing: `0 0 0 2px white, 0 0 0 4px ${colors.critical.border.default}`,
});

export const getFocusShadowsFromFlatColors = (
  colors: Record<string, string>
) => {
  const focusOuter = colors.interactiveFocusOuter;
  const surfacePrimary = colors.surfaceBackgroundPrimary;
  const criticalBorder = colors.criticalBorderDefault;

  if (process.env.NODE_ENV === 'development') {
    if (!focusOuter)
      // eslint-disable-next-line no-console
      console.warn(
        '[getFocusShadowsFromFlatColors] Missing interactiveFocusOuter token'
      );
    if (!surfacePrimary)
      // eslint-disable-next-line no-console
      console.warn(
        '[getFocusShadowsFromFlatColors] Missing surfaceBackgroundPrimary token'
      );
    if (!criticalBorder)
      // eslint-disable-next-line no-console
      console.warn(
        '[getFocusShadowsFromFlatColors] Missing criticalBorderDefault token'
      );
  }

  return {
    focusOutline: `0 0 0 2px ${focusOuter ?? 'transparent'}`,
    focusRing: `0 0 0 2px ${surfacePrimary ?? 'white'}, 0 0 0 4px ${
      focusOuter ?? 'transparent'
    }`,
    dangerRing: `0 0 0 2px white, 0 0 0 4px ${criticalBorder ?? 'red'}`,
  };
};
